function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _objectDestructuringEmpty(t) { if (null == t) throw new TypeError("Cannot destructure " + t); }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import * as React from 'react';
import { Reference } from 'react-popper';
import Button from "../Button";
var DropDownButton = /*#__PURE__*/function (_React$Component) {
  function DropDownButton() {
    var _this;
    _classCallCheck(this, DropDownButton);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _callSuper(this, DropDownButton, [].concat(args));
    _defineProperty(_this, "button", undefined);
    _defineProperty(_this, "setButtonRef", function (button) {
      _this.button = button;
    });
    /*
      The prop getter pattern allows the component to pass in a custom render function
      and its own props, and return additional props required to render the component.
      In this case, we use it to return a11y-related aria props, as well as control the
      onClick and onKeyDown handlers.
      For more info, see https://egghead.io/lessons/react-use-prop-getters-with-render-props
    */
    _defineProperty(_this, "getDropDownButtonProps", function () {
      var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
        props = _extends({}, (_objectDestructuringEmpty(_ref), _ref));
      var _this$props = _this.props,
        onClick = _this$props.onClick,
        onKeyDown = _this$props.onKeyDown;
      return _objectSpread(_objectSpread({
        onClick: onClick,
        onKeyDown: onKeyDown,
        ref: _this.setButtonRef
      }, _this.getAriaProps()), props);
    });
    _defineProperty(_this, "_popperRefHandler", undefined);
    _defineProperty(_this, "_setButtonRefWithPopper", undefined);
    _defineProperty(_this, "_getDropDownButtonPropsWithPopper", undefined);
    _defineProperty(_this, "memoizeSetButtonRefWithPopper", function (ref) {
      // Cache the ref to avoid creating new functions and thrashing the ref callbacks.
      if (_this._popperRefHandler !== ref) {
        _this._setButtonRefWithPopper = undefined;
        _this._getDropDownButtonPropsWithPopper = undefined;
      }
      if (!_this._setButtonRefWithPopper) {
        _this._setButtonRefWithPopper = function (node) {
          _this.setButtonRef(node);
          ref(node);
        };
      }
      return _this._setButtonRefWithPopper;
    });
    _defineProperty(_this, "memoizeGetDropDownButtonPropsWithPopper", function (ref) {
      var setButtonRef = _this.memoizeSetButtonRefWithPopper(ref);
      if (!_this._getDropDownButtonPropsWithPopper) {
        _this._getDropDownButtonPropsWithPopper = function (props) {
          return _this.getDropDownButtonProps(_objectSpread(_objectSpread({}, props), {}, {
            ref: setButtonRef
          }));
        };
      }
      return _this._getDropDownButtonPropsWithPopper;
    });
    return _this;
  }
  _inherits(DropDownButton, _React$Component);
  return _createClass(DropDownButton, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var autoFocus = this.props.autoFocus;
      if (autoFocus && this.button) {
        this.button.focus();
      }
    }
  }, {
    key: "getAriaProps",
    value: function getAriaProps() {
      var _this$props2 = this.props,
        ariaHasPopup = _this$props2.ariaHasPopup,
        ariaExpanded = _this$props2.ariaExpanded;
      return {
        'aria-haspopup': ariaHasPopup,
        'aria-expanded': ariaExpanded
      };
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;
      var _this$props3 = this.props,
        buttonProps = _this$props3.buttonProps,
        onClick = _this$props3.onClick,
        onKeyDown = _this$props3.onKeyDown,
        renderButton = _this$props3.renderButton,
        _this$props3$usePoppe = _this$props3.usePopper,
        usePopper = _this$props3$usePoppe === void 0 ? false : _this$props3$usePoppe;
      if (renderButton) {
        if (usePopper) {
          return /*#__PURE__*/React.createElement(Reference, null, function (_ref2) {
            var ref = _ref2.ref;
            return renderButton({
              getDropDownButtonProps: _this2.memoizeGetDropDownButtonPropsWithPopper(ref)
            });
          });
        } else {
          return renderButton({
            getDropDownButtonProps: this.getDropDownButtonProps
          });
        }
      }
      var renderProps = _objectSpread({
        onClick: onClick,
        htmlAttributes: _objectSpread(_objectSpread({
          onKeyDown: onKeyDown
        }, this.getAriaProps()), buttonProps && buttonProps.htmlAttributes)
      }, buttonProps);
      if (usePopper) {
        return /*#__PURE__*/React.createElement(Reference, null, function (_ref3) {
          var ref = _ref3.ref;
          return /*#__PURE__*/React.createElement(Button, _extends({}, renderProps, {
            _refAlt: _this2.memoizeSetButtonRefWithPopper(ref)
          }));
        });
      } else {
        return /*#__PURE__*/React.createElement(Button, _extends({}, renderProps, {
          _refAlt: this.setButtonRef
        }));
      }
    }
  }]);
}(React.Component);
export { DropDownButton as default };